
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-class-policy-web",
      function () {
        return require("private-next-pages/live-class-policy-web/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-class-policy-web"])
      });
    }
  